import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";

import "./sidebar.scss";
import { sidebarToggleItems } from "../../../utility/constants";
import dashicon from "../../../assets/images/layout-dashboard.svg";
import Booking from "../../../assets/images/bookingicon.svg";
import Finance from "../../../assets/images/financeicon.svg";
import Logout from "../../../assets/images/Logout.svg";
import Master from "../../../assets/images/Mastericon.svg";
import Drivericon from "../../../assets/images/driver-icon.svg";
import VehicleTypesDD from "../../form-controls/DropDowns/VehicleTypesDD";
import BranchListDD from "../../form-controls/DropDowns/BranchListDD";
import authorization from "../../../utility/authorization";
import Company from "../../../assets/images/companies.svg";
import Drivers from "../../../assets/images/Drivers.svg";
import Vehicle from "../../../assets/images/vehicle-icon.svg";
import Reports from "../../../assets/images/Reports.svg";
import Location from "../../../assets/images/location-a.svg";
import { fetchAccess as fetchBroadcastAccess } from "../../../containers/operatorBroadcast/api";
class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.authUser = this.props.auth.getAuthUser();
    this.state = { branchId: authorization.getBranchAccessSelected() };
    this.roleId = authorization.getAuthRoleId();
    this.userId = authorization.getAuthUserId();
  }

  toggleMenuItem = (type) => (e) => {
    e.stopPropagation(); // stop propagation to avoid parrent toggle
    this.props.dispatch({
      type: "TOGGLE_SIDEBAR_MENU",
      payload: {
        ...sidebarToggleItems,
        users:
          type === "drivers" ||
          type === "taxidaUsers" ||
          type === "operators" ||
          type === "finance" ||
          type === "master",

        [type]: !this.props.toggleItems[type],
      },
    });
  };

  mobToggleSidebar = () => {
    const mobile = window.matchMedia("(max-width: 768px)");
    if (mobile.matches) {
      this.props.dispatch({
        type: "TOGGLE_SIDEBAR",
        payload: { visible: true },
      });
    }
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    // Operator Broadcast menu only for operators Taxida enabled it for.
    // Re-checked when the tab regains focus so an admin ON/OFF shows without reload.
    this.loadBroadcastAccess();
    window.addEventListener("focus", this.loadBroadcastAccess);
  }

  loadBroadcastAccess = () => {
    fetchBroadcastAccess()
      .then((r) => this.setState({ broadcastEnabled: Boolean(r && r.enabled) }))
      .catch(() => this.setState({ broadcastEnabled: false }));
  };

  componentWillUnmount() {
    window.removeEventListener("focus", this.loadBroadcastAccess);
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleClickOutside = (e) => {
    const mobile = window.matchMedia("(max-width: 768px)");
    if (
      mobile.matches &&
      this.wrapperRef &&
      !this.wrapperRef.contains(e.target)
    ) {
      this.props.dispatch({
        type: "TOGGLE_SIDEBAR",
        payload: { visible: true },
      });
    }
  };
  onchangeDropDown = (name, value) => {
    authorization.setBranchAccessSelected(value);
    this.setState({ branchId: value }, () => {
      window.location.reload();
    });
  };

  render() {
    const {
      corporateEmail,
      firstName,
      accessMatrix,
      bookingApproval,
      newbookingReqForAdmins,
      showReports,
      showTripList,
      showTripsheet,
      isApiEnabled,
      fareApprovalEnabled,
      isGeneralTripsEnabled,
      isShuttleTripsEnabled,
    } = this.props.configCheck.response || "";
    const userRole = this.authUser.roleId || 0;
    let { additionalUserRole } = this.props.configCheck.response || [];
    additionalUserRole = additionalUserRole && additionalUserRole.split(",");
    const {
      sidebar: { visible: isOpen },
      toggleItems,
    } = this.props;
    const { branchId } = this.state;

    return (
      <>
        <div
          ref={this.setWrapperRef}
          className={isOpen ? "sidebar" : "sidebar open"}
        >
          <nav className="side-nav">
            <ul className="nav-list ">
              <div>
                <li className="list-items">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    tabIndex="1"
                    to="/dashboard"
                  >
                    <img src={dashicon} alt="booking" />
                    <span>Dashboard</span>
                  </NavLink>
                </li>
              </div>
              <div>
                <li className="list-items">
                  <NavLink
                    onClick={this.mobToggleSidebar}
                    tabIndex="1"
                    to="/booking-list"
                  >
                    <img src={Booking} alt="booking" />
                    <span>Booking</span>
                  </NavLink>
                </li>
              </div>
              {this.state.broadcastEnabled ? (
                <div>
                  <li className="list-items">
                    <NavLink
                      onClick={this.mobToggleSidebar}
                      tabIndex="1"
                      to="/operator-broadcast"
                    >
                      <img src={Booking} alt="operator broadcast" />
                      <span>Operator Broadcast</span>
                    </NavLink>
                  </li>
                </div>
              ) : null}

              <>
                {/* <div>
                  <li
                    className="list-items"
                    onClick={this.toggleMenuItem("finance")}
                  >
                    <button type="button" tabIndex="1">
                      <img src={Master} alt="newBook" />
                      <span>Finance</span>
                      <i
                        className={
                          toggleItems.finance ? "chevron down" : "chevron right"
                        }
                      />
                    </button>
                    <ul
                      className={
                        toggleItems.finance
                          ? "list-item-nav responsive"
                          : "list-item-nav"
                      }
                      onClick={(e) => e.stopPropagation()}
                    >
                      <li className="list-items list-bl">
                        <NavLink
                          onClick={this.mobToggleSidebar}
                          className="bl-pad"
                          to="/report"
                        >
                          <img src={Reports} alt="newBook" />

                          <span>Reports</span>
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </div> */}

                <li
                  className="list-items"
                  onClick={this.toggleMenuItem("master")}
                >
                  <button type="button" tabIndex="1">
                    <img src={Finance} alt="newBook" />
                    <span>Master data</span>
                    <i
                      className={
                        toggleItems.master ? "chevron down" : "chevron right"
                      }
                    />
                  </button>
                  <ul
                    className={
                      toggleItems.master
                        ? "list-item-nav responsive"
                        : "list-item-nav"
                    }
                    onClick={(e) => e.stopPropagation()}
                  >
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/associates"
                      >
                        {/*<div className="dot-icon"></div>*/}
                        <img src={Drivers} alt="newBook" className="sub-div" />
                        <span>Associates</span>
                      </NavLink>
                    </li>

                    <li className="list-items ">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/companies"
                      >
                        {/*<div className="dot-icon"></div>*/}
                        <img src={Company} alt="newBook" className="sub-div" />
                        <span>Companies</span>
                      </NavLink>
                    </li>

                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/operatingArea"
                      >
                        {/*<div className="dot-icon"></div>*/}
                        <img src={Location} alt="newBook" className="sub-div" />
                        <span>Operating area</span>
                      </NavLink>
                    </li>

                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/drivers"
                      >
                        {/*<div className="dot-icon"></div>*/}
                        <img
                          src={Drivericon}
                          alt="newBook"
                          className="sub-div"
                        />
                        <span>Drivers</span>
                      </NavLink>
                    </li>
                    <li className="list-items list-bl">
                      <NavLink
                        onClick={this.mobToggleSidebar}
                        className="bl-pad"
                        to="/vehicle"
                      >
                        {/*<div className="dot-icon"></div>*/}
                        <img src={Vehicle} alt="newBook" className="sub-div" />
                        <span>Vehicles</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </>
            </ul>
          </nav>
          <div className="log-side">
            <div className="log-border">
              <button
                onClick={this.props.auth.logout}
                tabIndex="1"
                to="/signout"
                className="log-btn"
              >
                <img src={Logout} alt="sign-out" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default connect((state) => {
  return {
    sidebar: state.sidebar,
    toggleItems: state.sidebarMenuToggle,
    configCheck: state.configCheck,
  };
})(Sidebar);
